/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Search Engines viewer. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.1, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["search-engines"] = "1.2.0"; } catch (e) {}
  /* The one thing worth explaining on this page is the absence: there is no keyword column, and
     people assume that is a bug. It is not — serp-engine.php spells it out: the core stores only
     referrer_host, never the full referrer URL, so the query string that would carry the keyword
     never reaches the database. That is a deliberate privacy choice, not a gap. */
  var ENGINE_HELP = {
    Google: TR('se.f.google_search_sends_no_keyword_to_the_'),
    Bing: TR('se.f.microsoft_bing'), Yahoo: TR('se.f.yahoo_search_powered_by_bing'),
    DuckDuckGo: TR('se.f.duckduckgo_sends_no_referrer_at_all_by'),
    Yandex: TR('se.f.yandex_the_main_russian_search_engine'), Baidu: TR('se.f.baidu_the_main_chinese_search_engine'),
    Ecosia: TR('se.f.ecosia_a_bing_backed_search_engine'), "Brave Search": TR('se.f.brave_s_independent_index'),
    Startpage: TR('se.f.startpage_a_privacy_front_end_to_googl'), Ask: TR('se.f.ask_com'), AOL: "AOL Search."
  };
  function engName(e) {
    var t = [];
    if (ENGINE_HELP[e.name]) t.push(ENGINE_HELP[e.name]);
    t.push(TR('se.f.no_keyword_is_available_for_any_engine'));
    if (e.pages_per_session != null) t.push("Pages per session: " + e.pages_per_session);
    if (e.conv_pct != null) t.push("Conversion rate: " + e.conv_pct + "%");
    return '<span class="eng-nm" title="' + esc(t.join("\n")) + '">' + esc(e.name) + "</span>";
  }

  
  function ic(n){return (window.GSIcons&&GSIcons.svg)?GSIcons.svg(n,16):"";}
if (window.__seWired) return; window.__seWired = 1;
  var root;
  function q(s) { return root ? root.querySelector('[data-s="' + s + '"]') : null; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  var MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  function fmtDate(ts) { var m = String(ts || "").match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? (MON[+m[2] - 1] + " " + (+m[3]) + ", " + m[1]) : "\u2014"; }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function ready(fn) { var done = false; function go() { if (done) return; done = true; fn(); } document.addEventListener("gs:ready", go, { once: true }); var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30); if (window.GS && GS.api && GS.site) go(); }
  function dur(s) { s = +s || 0; if (s < 60) return s + "s"; var m = Math.floor(s / 60); return m + "m " + (s % 60) + "s"; }

  function render(d) {
    var engines = d.engines || [], tot = d.totals || {};
    q("k-sessions").textContent = (tot.sessions || 0).toLocaleString();
    q("k-visitors").textContent = (tot.visitors || 0).toLocaleString();
    q("k-engines").textContent = (tot.engines || 0).toLocaleString();
    q("k-top").innerHTML = d.top ? esc(d.top) + ' <span class="num" style="color:var(--muted);font-size:13px">' + d.top_share + "%</span>" : "\u2014";

    var board = q("board");
    if (!engines.length) { board.innerHTML = '<div class="empty">'+TR('se.f.no_search_traffic_in_this_range')+'</div>'; }
    else {
      var max = engines[0].share || 1;
      board.innerHTML = engines.map(function (e) {
        return '<div class="brow se-clk" data-eng="' + esc(e.name) + '" title="See visitors from ' + esc(e.name) + '"><div class="top">' + (ic(e.name) ? '<span class="ei">' + ic(e.name) + '</span>' : '<span class="dot" style="background:' + esc(e.color) + '"></span>') + engName(e) +
          '<span class="pct num">' + e.share + '%</span></div>' +
          '<div class="track"><i style="width:' + Math.max(3, Math.round(e.share / max * 100)) + '%;background:' + esc(e.color) + '"></i></div>' +
          '<div class="n">' + e.sessions.toLocaleString() + ' sessions \u00b7 ' + e.visitors.toLocaleString() + ' visitors</div></div>';
      }).join("");
    }

    var tb = q("tbody");
    tb.innerHTML = engines.length ? engines.map(function (e) {
      return '<tr class="se-clk" data-eng="' + esc(e.name) + '" title="See visitors from ' + esc(e.name) + '"><td><span class="eng">' + (ic(e.name) ? '<span class="ei">' + ic(e.name) + '</span>' : '<span class="dot" style="background:' + esc(e.color) + '"></span>') + engName(e) + ' <i class="bi bi-chevron-right se-chev"></i></span></td>' +
        '<td class="r num">' + e.visitors.toLocaleString() + '</td>' +
        '<td class="r num">' + e.sessions.toLocaleString() + '</td>' +
        '<td class="r num">' + e.pages_per_session + '</td>' +
        '<td class="r num">' + dur(e.avg_seconds) + '</td>' +
        '<td class="r conv num">' + e.conv_pct + '%</td>' +
        '<td class="r num">' + e.share + '%</td></tr>';
    }).join("") : '<tr><td colspan="7" class="empty">'+TR('se.f.no_search_traffic_in_this_range')+'</td></tr>';
  }
  /* ── Search Intent Intelligence ─────────────────────────────────────────────
     Engine crossed with behaviour. The interesting question now is whether an
     AI assistant sends a different person than a search box does. No keyword
     panels: engines stopped sending query terms, so there is nothing to show. */
  var SEI_STAGES = ["exploration","evaluation","comparison","commitment"];
  var SEI = { AC:"#1FA463", RD:"#DC2626", PU:"#6C4BE8", BL:"#2A6FE8", MU:"#8C95A1" };

  function seiNum(n){ n=+n||0; return n>=1e6?(n/1e6).toFixed(1)+"M":n>=1e3?(n/1e3).toFixed(1)+"k":String(n); }
  function seiTriad(b){
    if(!b) return '<div class="gs-muted small">'+TR('se.f.no_behavioural_scores_yet')+'</div>';
    return [[TR('se.f.intent'),b.intent,SEI.AC],[TR('se.f.friction'),b.frustration,SEI.RD],[TR('se.f.attention'),b.attention,SEI.PU]]
      .map(function(t){ return '<div class="se-i-tri"><span>'+t[0]+'</span><i><b style="width:'
        +Math.max(0,Math.min(100,t[1]))+'%;background:'+t[2]+'"></b></i><em>'+t[1]+'</em></div>'; }).join("");
  }
  function seiCards(d){
    var host=q("sei-cards"); if(!host) return;
    var rows=d.engines||[];
    if(!rows.length){ host.innerHTML='<div class="empty">'+TR('se.f.no_search_traffic_in_this_range')+'</div>'; return; }
    var note=q("sei-note");
    if(note && !d.has_behaviour && d.notes && d.notes.behaviour) note.textContent=d.notes.behaviour;
    host.innerHTML=rows.map(function(r){
      var p=(r.personas&&r.personas[0])||null;
      var land=(r.landing||[]).slice(0,3).map(function(l){
        return '<a class="se-i-land" href="/heatmaps?page='+encodeURIComponent(l.path)+'"><span>'
             +esc(l.path)+'</span><b>'+seiNum(l.sessions)+'</b></a>'; }).join("");
      return '<article class="se-i-card">'
        +'<div class="se-i-card-h">'+ic(r.key)+'<b>'+esc(r.key)+'</b>'
        +(r.ai?'<span class="se-i-ai" title="'+TT('se.tip_ai')+'">AI</span>':"")
        +'<span class="se-i-share" style="color:'+(r.color||SEI.MU)+'">'+r.share+'%</span></div>'
        +'<div class="se-i-stats"><span>'+seiNum(r.sessions)+' sessions</span><span>'+seiNum(r.visitors)+' visitors</span><span>'+r.pages_per_session+' pages/visit</span></div>'
        +'<div class="se-i-triad">'+seiTriad(r.behaviour)+'</div>'
        +(p?'<div class="se-i-persona">'+TR('se.f.mostly')+'<b>'+esc(p.label)+'</b> · '+p.pct+'%</div>':"")
        +(land?'<div class="se-i-lands">'+land+'</div>':"")
        +'</article>';
    }).join("");
  }
  function seiJourney(d){
    var host=q("sei-journey"); if(!host) return;
    var rows=(d.engines||[]).filter(function(r){ return r.journeys && r.journeys.length; });
    if(!rows.length){ host.innerHTML='<div class="gs-muted small">'+
      (d.has_behaviour?TR('search.p.no_journey_stages_scored_in_this_ran'):((d.notes&&d.notes.behaviour)||""))+'</div>'; return; }
    var col={exploration:"#8C95A1",evaluation:SEI.BL,comparison:SEI.PU,commitment:SEI.AC};
    host.innerHTML=rows.map(function(r){
      var by={}; r.journeys.forEach(function(j){ by[String(j.label).toLowerCase()]=j.pct; });
      var segs=SEI_STAGES.filter(function(s){return by[s];}).map(function(s){
        return '<i style="width:'+by[s]+'%;background:'+col[s]+'" title="'+s+' '+by[s]+'%"></i>'; }).join("");
      var top=r.journeys[0];
      return '<div class="se-i-jrow"><div class="se-i-jh">'+ic(r.key)+'<b>'+esc(r.key)+'</b>'
        +'<span class="gs-muted">'+esc(top.label)+' '+top.pct+'%</span></div>'
        +'<div class="se-i-jbar">'+segs+'</div></div>';
    }).join("")
    +'<div class="se-i-jkey">'+SEI_STAGES.map(function(s){
        return '<span><i style="background:'+col[s]+'"></i>'+s+'</span>'; }).join("")+'</div>';
  }
  function seiFail(msg){
    var w=q("sei"); if(!w) return; w.hidden=false;
    var h=q("sei-cards"); if(h) h.innerHTML='<div class="empty">'+esc(msg)+'</div>';
  }
  function loadIntel(){
    var wrap=q("sei");
    if(!wrap){ if(window.console) console.warn('[search-engines] no [data-s="sei"] — template not deployed?'); return; }
    if(!window.GS||!GS.api){ seiFail(TR('se.f.ghoststat_app_scripts_did_not_load')); return; }
    if(!GS.site) return;
    GS.api("/plugin/search-engines/intel?site="+encodeURIComponent(GS.site)+"&from="+RANGE.from+"&to="+RANGE.to)
      .then(function(r){
        var d=(r&&r.data)?r.data:r;
        if(!d){ seiFail(TR('se.f.no_response_from_the_intel_endpoint')); return; }
        if(d.gated){ seiFail(TR('se.f.search_intent_isn_t_available_on_your_')); return; }
        if(d.error==="plugin_not_loaded"){ seiFail(TR('se.f.search_engines_isn_t_enabled_for_this_')); return; }
        if(!d.engines){ seiFail(TR('se.f.the_intel_endpoint_returned_nothing_us')); return; }
        wrap.hidden=false;
        var t=q("sei-tot");
        if(t&&d.totals) t.innerHTML=seiNum(d.totals.sessions)+" sessions &middot; "+seiNum(d.totals.visitors)+" visitors";
        seiCards(d); seiJourney(d);
        var kw=q("sei-kw");
        if(kw && d.notes && d.notes.keywords) kw.textContent=d.notes.keywords;
      })
      .catch(function(e){
        seiFail(TR('search.p.could_not_load_search_intent')+((e&&e.message)||"request failed")+").");
        if(window.console) console.warn("[search-engines] intel request failed", e);
      });
  }


  function load() {
    loadIntel();
    GS.api("/plugin/search-engines/engines?" + siteParam() + "&from=" + RANGE.from + "&to=" + RANGE.to).then(function (r) {
      if (r.ok && r.data) render(r.data);
    });
  }

  function _ymd(d) { return d.getUTCFullYear() + "-" + ("0" + (d.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2); }
  function _today() { var t = new Date(); return new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate())); }
  function T(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function preset(days) { var to = _today(), from = new Date(to.getTime() - (days - 1) * 86400000); var lbl = { 7: T("an.last7"), 30: T("an.last30"), 90: T("an.last90"), 365: T("an.last12mo") }[days] || T("an.lastndays",{n:days}); return { from: _ymd(from), to: _ymd(to), label: lbl, preset: String(days) }; }
  var RANGE = (function () { try { var s = JSON.parse(localStorage.getItem("gs_se_range") || "null"); /* A stored preset is a RULE ("last 30 days"), not a fixed window. Restoring its
     absolute from/to means "last 30 days" quietly becomes "the 30 days ending whenever
     you last touched the picker" — today falls outside the range, the page looks stale,
     and Refresh re-queries the same dead window forever. Re-anchor presets to today;
     a CUSTOM range is genuinely absolute and is kept as stored. */
  if (s && s.preset) return preset(+s.preset);
  if (s && s.from && s.to) return s; } catch (e) {} return preset(30); })();
  function saveRange() { try { localStorage.setItem("gs_se_range", JSON.stringify(RANGE)); } catch (e) {} }

  function initRange() {
    var btn = q("rangeBtn"), menu = q("rangeMenu"), lab = q("range-label"); if (!btn || !menu) return;
    if (lab && RANGE.label) lab.textContent = RANGE.label;
    function sync() { menu.querySelectorAll(".rm[data-preset]").forEach(function (x) { x.classList.toggle("on", x.getAttribute("data-preset") === RANGE.preset); }); }
    sync();
    btn.addEventListener("click", function (e) { if (menu.contains(e.target) && e.target !== btn) return; e.stopPropagation(); var open = menu.style.display !== "none"; menu.style.display = open ? "none" : "block"; if (!open) { var cf = menu.querySelector('[data-rp="from"]'), ct = menu.querySelector('[data-rp="to"]'); if (cf) cf.value = RANGE.from; if (ct) ct.value = RANGE.to; sync(); } });
    document.addEventListener("click", function () { menu.style.display = "none"; });
    menu.addEventListener("click", function (e) { e.stopPropagation(); });
    function apply(r) { RANGE = r; if (lab) lab.textContent = RANGE.label; saveRange(); menu.style.display = "none"; load(); }
    menu.querySelectorAll(".rm[data-preset]").forEach(function (b) { b.addEventListener("click", function () { apply(preset(+b.getAttribute("data-preset"))); }); });
    var ap = menu.querySelector('[data-rp="apply"]'); if (ap) ap.addEventListener("click", function () { var f = menu.querySelector('[data-rp="from"]').value, t = menu.querySelector('[data-rp="to"]').value; if (!f || !t) return; if (f > t) { var x = f; f = t; t = x; } apply({ from: f, to: t, label: f + " \u2192 " + t, preset: null }); });
  }
  function sevRow(v) {
    var meta = [v.device, v.browser, v.os].filter(Boolean).join(" \u00b7 ");
    var dates = (v.first_seen || v.last_seen) ? ('<span class="sev-dates"><i class="bi bi-calendar3"></i> First ' + esc(fmtDate(v.first_seen)) + ' \u00b7 Last ' + esc(fmtDate(v.last_seen)) + '</span>') : '';
    return '<div class="sev-row"><div class="sev-left"><span class="sev-av">' + esc((v.short || (v.vid || "?")).slice(0, 2).toUpperCase()) + '</span>' +
      '<span class="sev-text"><span class="sev-id">' + esc(v.short || (v.vid || "").slice(0, 8)) + '</span><span class="sev-meta">' + esc(meta || "\u2014") + '</span>' + dates + '</span></div>' +
      '<span class="sev-stats">' + (+v.sessions || 0) + ' sess \u00b7 ' + (+v.pageviews || 0) + ' pv</span>' +
      '<a class="sev-open" href="/visitor-intelligence?id=' + encodeURIComponent(v.vid) + '">Open in Visitor Intelligence \u2192</a></div>';
  }
  function showEngineVisitors(engine) {
    var panel = q("visitors"); if (!panel) return;
    panel.hidden = false;
    panel.innerHTML = '<div class="sev-h"><span>'+TT('se.js_visitors_from')+'<b>' + esc(engine) + '</b> <span class="sev-sub">(bots excluded)</span></span><button class="sev-close" type="button" aria-label="'+TT('se.at.close')+'">\u00d7</button></div><div class="sev-body"><div class="sev-load">Loading visitors\u2026</div></div>';
    panel.querySelector(".sev-close").onclick = function () { panel.hidden = true; };
    try { panel.scrollIntoView({ behavior: "smooth", block: "nearest" }); } catch (e) {}
    var url = "/plugin/search-engines/visitors?" + siteParam() + "&engine=" + encodeURIComponent(engine) + "&from=" + RANGE.from + "&to=" + RANGE.to;
    GS.api(url).then(function (r) {
      var d = (r && r.data) ? r.data : (r || {}), rows = d.rows || [], body = panel.querySelector(".sev-body");
      var emptyHtml = '<div class="sev-empty">No non-bot visitors from ' + esc(engine) + ' in this range.</div>';
      if (window.GSMore) {
        window.GSMore.mount({ container: body, listClass: "sev-list", items: rows, pageSize: 20, autoload: true, emptyHtml: emptyHtml, render: sevRow });
      } else if (!rows.length) { body.innerHTML = emptyHtml; }
      else { body.innerHTML = '<div class="sev-list">' + rows.map(sevRow).join("") + '</div>'; }
    }).catch(function () { var b = panel.querySelector(".sev-body"); if (b) b.innerHTML = '<div class="sev-empty">Couldn\u2019t load visitors.</div>'; });
  }

  function init() { root = document.querySelector('[data-s="root"]'); if (!root) return; var rf = q("refresh"); if (rf) rf.addEventListener("click", load);
    root.addEventListener("click", function (e) { var el = e.target.closest ? e.target.closest("[data-eng]") : null; if (el && root.contains(el)) showEngineVisitors(el.getAttribute("data-eng")); });
    initRange(); load(); }
  ready(init);
})();
